import { useState } from "react";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/solid";

import ListActivities from "./components/ListActivities";
import AddActivity from "./components/AddActivity";

const ActivityTracker = props => {
  const [open, setOpen] = useState(false);

  return (
    <div className="relative w-full overflow-y-auto border-t border-gray-200 bg-white lg:absolute lg:bottom-0 lg:right-0 lg:top-0 lg:min-h-full lg:w-auto lg:border-l lg:border-t-0">
      {open ? (
        <div className="w-full flex-col px-4 py-8 lg:w-[640px] lg:px-[40px] lg:py-[60px]">
          <div className="flex w-full flex-row items-center justify-center">
            <ChevronRightIcon
              className="h-5 w-5 cursor-pointer"
              onClick={() => setOpen(false)}
            />
            <div className="ml-[20px] flex-1 text-2xl font-bold tracking-wider">
              Record an Activity
            </div>
          </div>
          <AddActivity {...props} />
          <ListActivities {...props} />
        </div>
      ) : (
        <div className="flex items-center gap-3 px-[14px] py-[20px] lg:min-h-full lg:flex-col lg:items-stretch lg:gap-0">
          <ChevronLeftIcon
            className="h-5 w-5 cursor-pointer"
            onClick={() => setOpen(true)}
          />
          <div className="relative flex lg:min-h-full">
            <div className="whitespace-nowrap text-lg font-bold lg:absolute lg:left-2/4 lg:top-[75px] lg:-translate-x-1/2 lg:-translate-y-1/2 lg:-rotate-90 lg:transform">
              Record Activity
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ActivityTracker;
